<script setup lang="ts">
import { ref } from 'vue'
import { onBeforeRouteUpdate, useRouter } from 'vue-router'

enum CustomerProfileTabs {
  WorkOrders = 'rc-customer-work-orders',
  RSA = 'rc-customer-rsas',
  RepairRequests = 'rc-customer-repair-requests',
}

const router = useRouter()

onBeforeRouteUpdate(async (to) => {
  selectedTab.value = to.name as string
})

const selectedTab = ref(router.currentRoute.value.name?.toString())

const props = defineProps<{
  customerId: number
}>()
</script>

<template>
  <div class="flex gap-4 mb-6">
    <el-check-tag
      class="font-normal rounded-full"
      :checked="selectedTab === CustomerProfileTabs.WorkOrders"
      round
      effect="plain"
      @click="router.push({ name: CustomerProfileTabs.WorkOrders, params: { customerId: props.customerId } })"
    >
      Work Orders
    </el-check-tag>
    <el-check-tag
      class="font-normal rounded-full"
      :checked="selectedTab === CustomerProfileTabs.RSA"
      round
      effect="plain"
      @click="router.push({ name: CustomerProfileTabs.RSA, params: { customerId: props.customerId } })"
    >
      RSA
    </el-check-tag>
    <el-check-tag
      class="font-normal rounded-full"
      :checked="selectedTab === CustomerProfileTabs.RepairRequests"
      round
      effect="plain"
      @click="router.push({ name: CustomerProfileTabs.RepairRequests, params: { customerId: props.customerId } })"
    >
      Repair Requests
    </el-check-tag>
  </div>
  <div class="p-2">
    <router-view />
  </div>
</template>
